import FancyButton from "@/components/ui/fancy-button";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";
import Image from "next/image";
import Link from "next/link";

import { cn } from "@/lib/utils";
import Logo from "../../Logo";
import { menuItems } from "../utils/consts";
import { NavLink } from "./nav-link";

const DesktopMenuContent = () => (
  <NavigationMenu className="h-full w-3/5 lg:w-1/2">
    <NavigationMenuList className="space-x-5">
      <NavigationMenuItem>
        <NavigationMenuTrigger className="md:text-sm lg:text-base xl:text-lg">
          Features
        </NavigationMenuTrigger>
        <NavigationMenuContent>
          <ul className="relative grid md:w-[550px] lg:w-[650px] lg:grid-cols-[1.25fr_.75fr]">
            <li className="row-span-3 border-r border-slate-200 p-4">
              <p className="pb-1 text-[10px]">GENERATE VIDEOS</p>
              <div>
                {menuItems.features.generateVideos.map((item) => (
                  <NavLink key={item.title} {...item} />
                ))}
              </div>
            </li>
            <li className="relative">
              <div className="relative z-10 p-4">
                <p className="pb-1 text-[10px]">CRAYO TOOLS</p>
                {menuItems.features.tools.map((item) => (
                  <NavLink key={item.title} {...item} />
                ))}
              </div>
            </li>
          </ul>
        </NavigationMenuContent>
      </NavigationMenuItem>

      <NavigationMenuItem>
        <NavigationMenuTrigger className="md:text-sm lg:text-base xl:text-lg">
          Resources
        </NavigationMenuTrigger>
        <NavigationMenuContent>
          <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
            {menuItems.resources.map((item) => (
              <NavLink key={item.title} {...item} />
            ))}
          </ul>
        </NavigationMenuContent>
      </NavigationMenuItem>

      <NavigationMenuItem>
        <Link href="/blog" legacyBehavior passHref>
          <NavigationMenuLink
            className={cn(navigationMenuTriggerStyle(), "md:text-sm lg:text-base xl:text-lg")}
          >
            Blog
          </NavigationMenuLink>
        </Link>
      </NavigationMenuItem>

      <NavigationMenuItem>
        <Link href="/pricing" legacyBehavior passHref>
          <NavigationMenuLink
            className={cn(navigationMenuTriggerStyle(), "md:text-sm lg:text-base xl:text-lg")}
          >
            Pricing
          </NavigationMenuLink>
        </Link>
      </NavigationMenuItem>
    </NavigationMenuList>
  </NavigationMenu>
);

export const DesktopNavbar = ({ className }: { className?: string }) => (
  <header
    id="top"
    className={cn(
      "sticky top-0 z-50 hidden w-full overflow-visible md:flex md:items-center md:justify-center",
      className,
    )}
  >
    <div
      className="absolute inset-0 bg-white"
      style={{
        background:
          "linear-gradient(to bottom, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.7) 70%, rgba(255, 255, 255, 0.4) 95%, transparent 100%)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        maskImage: "linear-gradient(to bottom, black 0%, black 90%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(to bottom, black 0%, black 90%, transparent 100%)",
      }}
    />

    <div className="relative mx-auto flex w-[95%] items-center justify-between px-5 pb-4 pt-6 xl:max-w-screen-2xl">
      <Logo
        href="/"
        onClick={(e) => {
          if (window.location.pathname === "/") {
            e.preventDefault();
          }
        }}
      />
      <div className="hidden w-full items-center justify-center md:flex md:w-fit">
        <DesktopMenuContent />
      </div>
      <FancyButton
        className="flex items-center justify-center gap-1.5"
        size="lg"
        href="https://crayo.ai/dashboard"
      >
        <Image
          src="https://cdn-crayo.com/lp/public/lightningWhite.png"
          alt="Lightning"
          width={12}
          height={14}
          draggable={false}
          style={{
            userSelect: "none",
            pointerEvents: "none",
            touchAction: "none",
          }}
        />
        <span className="whitespace-nowrap text-base text-white">Try Crayo Now</span>
      </FancyButton>
    </div>
  </header>
);

export default DesktopNavbar;
